/* ==========================================================================
   Alwayz Clean Lab - hero.js
   <hero-slideshow>: crossfade slides, story-style progress bars, autoplay that
   pauses on hover / focus / hidden tab / off-screen, swipe + keyboard.
   ========================================================================== */
(() => {
  'use strict';
  const A = window.Alwayz;
  const { $, $$, define, reduceMotion } = A;

  class HeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = $$('[data-slide]', this);
      this.segs = $$('[data-seg]', this);
      this.index = 0;
      this.speed = (+this.dataset.speed || 7) * 1000;
      this.autoplay = this.dataset.autoplay !== 'false' && !reduceMotion && this.slides.length > 1;
      this.paused = false;

      this.segs.forEach((s, i) => s.addEventListener('click', () => this.go(i, true)));
      const prev = $('[data-hero-prev]', this);
      const next = $('[data-hero-next]', this);
      prev && prev.addEventListener('click', () => this.go(this.index - 1, true));
      next && next.addEventListener('click', () => this.go(this.index + 1, true));

      this.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') this.pause(); });
      this.addEventListener('pointerleave', () => this.resume());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', () => this.resume());
      document.addEventListener('visibilitychange', () => (document.hidden ? this.pause() : this.resume()));
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([e]) => { this.visible = e.isIntersecting; e.isIntersecting ? this.resume() : this.pause(); }, { threshold: 0.35 }).observe(this);
      }
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.go(this.index - 1, true);
        if (e.key === 'ArrowRight') this.go(this.index + 1, true);
      });

      // swipe
      let x0 = null;
      this.addEventListener('pointerdown', (e) => { if (e.pointerType === 'touch') x0 = e.clientX; });
      this.addEventListener('pointerup', (e) => {
        if (x0 === null) return;
        const dx = e.clientX - x0;
        x0 = null;
        if (Math.abs(dx) > 50) this.go(this.index + (dx < 0 ? 1 : -1), true);
      });

      this.mark();
      if (this.autoplay) this.schedule();
    }
    mark() {
      this.slides.forEach((s, i) => {
        s.classList.toggle('is-active', i === this.index);
        s.setAttribute('aria-hidden', String(i !== this.index));
        $$('a, button', s).forEach((el) => { el.tabIndex = i === this.index ? 0 : -1; });
      });
      this.segs.forEach((s, i) => {
        // restart the fill animation
        s.classList.remove('is-active');
        s.classList.toggle('is-done', i < this.index);
        s.setAttribute('aria-selected', String(i === this.index));
      });
      void this.offsetWidth;
      if (this.segs[this.index]) this.segs[this.index].classList.add('is-active');
    }
    go(i, manual) {
      const n = this.slides.length;
      this.index = (i + n) % n;
      this.mark();
      if (manual) { this.autoplay = this.autoplay && true; }
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.autoplay || this.paused) return;
      this.remaining = this.speed;
      this.startedAt = performance.now();
      this.timer = setTimeout(() => this.go(this.index + 1), this.remaining);
    }
    pause() {
      if (this.paused) return;
      this.paused = true;
      this.setAttribute('data-paused', 'true');
      if (this.timer) { clearTimeout(this.timer); this.remaining = Math.max(400, this.speed - (performance.now() - this.startedAt)); }
    }
    resume() {
      if (!this.paused) return;
      if (this.visible === false) return;
      this.paused = false;
      this.setAttribute('data-paused', 'false');
      if (!this.autoplay) return;
      this.startedAt = performance.now() - (this.speed - (this.remaining || this.speed));
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.go(this.index + 1), this.remaining || this.speed);
    }
  }
  define('hero-slideshow', HeroSlideshow);
})();
